import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";


import Photo from "../assets/img/profile-img.jpg";

const ViewWallet = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let wallet = location.state.wallet;


    const [showWallet, setShowWallet] = useState(false);

    const [usdtWallet, setUSDTWallet] = useState([]);
    const [btcWallet, setBTCWallet] = useState([]);

    useEffect(() => {
      getUserWallet();
    }, []);

  

  async function getUserWallet() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get(`/admin/wallet/${wallet.id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        setBTCWallet(res.data.btc_wallet);
        setUSDTWallet(res.data.usdt_wallet);
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }


  return (
    <div>
            <Header/>
            <Sidebar/>
            <main id="main" className="main">
              <div className="pagetitle">
                <h1>Wallets</h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/wallets">Wallets</a></li>
                    <li className="breadcrumb-item active">Wallet</li>
                  </ol>
                </nav>
              </div>{/* End Page Title */}
              
                <section className="section profile">
                    <div className="row">
                    <div className="col-xl-4">
                        <div className="card">
                        <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                            <img src="https://cdn3d.iconscout.com/3d/premium/thumb/bitcoin-wallet-4304996-3581337.png" alt="Wallet"  />
                            <h3>{wallet.first_name} {wallet.last_name}</h3>
                            <div className="social-links mt-2">
                            <a href="#"><i className="bi bi-patch-check" /> Active</a>
                            </div>
                        </div>
                        </div>
                        <div class="d-grid gap-2 mt-3">
                            {!showWallet ? 
                            <a class="btn btn-primary mb-2" onClick={() => setShowWallet(true)}>Show Wallet Details</a> : 
                            <a class="btn btn-info mb-2" onClick={() => setShowWallet(false)}>Hide Wallet Details</a>}
                            {/* <a class="btn btn-warning mb-2" onClick={() => {}}>Block Wallet</a> */}
                            <a class="btn btn-danger mb-2" onClick={() => {}}>Lock Wallet</a>
                        </div>

                        <div className="modal fade" id="verification" tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                <h5 className="modal-title">KYC Verification</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                This check costs N50.00 via flutterwave BVN verification API, make sure user provides correct details for proper check.
                                </div>
                                <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" data-bs-dismiss="modal" onClick={()=>{}} className="btn btn-primary">Proceed</button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="card">
                        <div className="card-body pt-3">
                            {/* Bordered Tabs */}
                            <ul className="nav nav-tabs nav-tabs-bordered">
                            <li className="nav-item">
                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#profile-overview">Overview</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#usdt-wallet">USDT Wallet</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#btc-wallet">BTC Wallet</button>
                            </li>
                            </ul>
                            <div className="tab-content pt-2">
                            <div className="tab-pane fade show active profile-overview" id="profile-overview">
                                <h5 className="card-title">Wallet Details</h5>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Customer Name</div>
                                <div className="col-lg-9 col-md-8">{wallet.first_name} {wallet.last_name}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Customer Email</div>
                                <div className="col-lg-9 col-md-8">{wallet.email}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Reference ID</div>
                                <div className="col-lg-9 col-md-8">{showWallet ? wallet.id : "*******"}</div>
                                </div>
                                <h5 className="card-title">Deposit Address</h5>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">USDT Address</div>
                                    <div className="col-lg-9 col-md-8">{showWallet ? usdtWallet.deposit_address : "*********************"}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">BTC Address</div>
                                    <div className="col-lg-9 col-md-8">{showWallet ? btcWallet.deposit_address : "*********************"}</div>
                                </div>

                            </div>
                            <div className="tab-pane fade show profile-overview" id="usdt-wallet">
                                <h5 className="card-title">Wallet Details</h5>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">USDT Balance</div>
                                    <div className="col-lg-9 col-md-8">{usdtWallet.balance}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Locked</div>
                                    <div className="col-lg-9 col-md-8">{usdtWallet.locked}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Deposit Address</div>
                                    <div className="col-lg-9 col-md-8">{usdtWallet.deposit_address}</div>
                                </div>
                                <h5 className="card-title">All Transactions</h5>
                                
                            </div>
                            <div className="tab-pane fade show profile-overview" id="btc-wallet">
                                <h5 className="card-title">Wallet Details</h5>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">BTC Balance</div>
                                    <div className="col-lg-9 col-md-8">{btcWallet.balance}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Locked</div>
                                    <div className="col-lg-9 col-md-8">{btcWallet.locked}</div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-3 col-md-4 label ">Deposit Address</div>
                                    <div className="col-lg-9 col-md-8">{btcWallet.deposit_address}</div>
                                </div>
                                <h5 className="card-title">All Transactions</h5>
                                
                            </div>
                            </div>{/* End Bordered Tabs */}
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            </main>{/* End #main */}
           <Footer/>
            <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
          </div>
      );

}


export default ViewWallet;